import { supabase } from "../supabase/supabaseClient";

export async function fetchFlightsByPlacement(code: string) {
  const now = new Date().toISOString();
  const { data, error } = await supabase
    .from("ad_flights")
    .select(`id, placement_code, weight, start_at, end_at, is_active, target_rules,
             ad_creatives:creative_id ( id, title, img_url, click_url, width, height )`)
    .eq("placement_code", code)
    .eq("is_active", true)
    .lte("start_at", now)
    .gte("end_at", now);
  if (error) return [];
  return (data || []).filter((d:any)=> d.ad_creatives?.img_url);

}

function ensureAnon() {
  const k = "ab_anon";
  let v = localStorage.getItem(k);
  if (!v) { v = crypto.randomUUID(); localStorage.setItem(k, v); }
  return v;
}

export async function logImpression(flightId: string) {
  try { await supabase.rpc("log_ad_impression", { p_flight: flightId, p_anon: ensureAnon(), p_uid: null }); } catch {}
}
export async function logClick(flightId: string) {
  try { await supabase.rpc("log_ad_click", { p_flight: flightId, p_anon: ensureAnon(), p_uid: null }); } catch {}
}
